import { BookmarkIcon } from "@heroicons/react/24/outline";
import { observer } from "mobx-react-lite";
import { useBoolean } from "src/hooks/useBoolean";
import { Button } from "src/components/Button";
import { SaveModal } from "src/components/SaveModal";
import type { World } from "src/types/World";
import { useTranslation } from "src/translations";

export const SaveButton = observer(function ExportButton(props: { world: World | null }) {
  const showModal = useBoolean();
  const { t } = useTranslation();

  return (
    <>
      <Button title={t("toolbox.save")} Icon={BookmarkIcon} onClick={showModal.on} />
      {showModal.isOn && props.world && <SaveModal onClose={showModal.off} world={props.world} />}
    </>
  );
});
